import { createFileRoute } from "@tanstack/react-router";
import { KioskDisplay } from "@/components/attendance/kiosk-display";
import { requireView } from "@/core/lib/guards";
import { companyQuery } from "@/lib/workspace-data";

/**
 * The full-screen check-in display for an entrance computer. Outside the
 * workspace shell (no sidebar or header), but behind the same guard: a signed-in
 * HR member opens it from a session's page, so there is no separate device
 * credential to issue or leak.
 */
export const Route = createFileRoute("/kiosk/attendance/$id")({
  beforeLoad: async ({ context, location }) => {
    await requireView(context.queryClient, "user", "/sign-in", location.href);
  },
  loader: ({ context }) => context.queryClient.ensureQueryData(companyQuery),
  component: KioskPage,
});

function KioskPage() {
  const { id } = Route.useParams();
  return <KioskDisplay sessionId={id} />;
}
